import React from "react";
import { Row, Col } from 'react-bootstrap'
import AscComponent from "../../../components/AscComponent";
import ColumnFixTable from '../../../containers/Elements/Table/ColumnFixTable';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default class Summaries extends AscComponent {
    constructor(props) {
        super(props);
        this.state = {
            columns: this.getColumnsData(),
            data: Array.isArray(props.state.data) ? props.state.data : [],
            pages: null,
            pageSize: null,
            loading: false,
            filtered: []
        }

        this.table = React.createRef();
    }

    // グループ行の開閉トグル。
    // 引数のグループ名(キー)に対して、折りたたみ/展開状態を反転させる。
    toggleGroup = (groupKey) => {
        if (this.props.onToggleGroup) this.props.onToggleGroup(groupKey);
    }

    // 表示用のデータ配列を構築する。
    // ルール:
    // 1) グループ行(is_group)を先に出力し、直後にそのグループ配下のオペレーター行を並べる。
    // 2) 同一オペレーターが複数グループに属する場合、該当グループごとに行を重複表示する。
    // 3) 折りたたみ状態(collapsedGroups)のグループは、配下オペレーターを非表示にする。
    // 4) いずれのグループにも属さないオペレーター行は最後に出力する。
    buildDisplayData() {
        const { view_level } = this.props.state;
        if (view_level !== 'CallAnalysisSummaryByOperator') return this.state.data;

        const collapsed = this.props.collapsedGroups || {};

        const result = [];
        let currentGroup = null;
        for (let i = 0; i < this.state.data.length; i++) {
            const row = this.state.data[i];
            if (row && row.is_group) {
                // 新しいグループ開始
                currentGroup = row.key_as_string;
                result.push(row);
                continue;
            }
            if (currentGroup) {
                // グループ行の直後から次のグループ行が現れるまでを、そのグループのメンバーとみなす
                if (!collapsed[currentGroup]) result.push(row);
                continue;
            }
            // グループ外(残り)の行
            result.push(row);
        }
        return result;
    }

    getCellStyle(rowInfo, cellKey) {
        let totalRow = [];
        if (this.state.data.length > 0) {  
            totalRow = this.state.data.find(row => row.key_as_string === "average" || row.key_as_string === "median");
        }

        let styleObj = {
            background: null,
            color: null
        };

        let cellValue = null;
        if (rowInfo && rowInfo.original && rowInfo.original[cellKey] && 
            rowInfo.original["key_as_string"] !== "average" && rowInfo.original["key_as_string"] !== "median") {
                if (rowInfo.original[cellKey].values && rowInfo.original[cellKey].values['50.0'] !== undefined) {
                    cellValue = rowInfo.original[cellKey].values['50.0'];
                } else if (rowInfo.original[cellKey].value !== undefined) {
                    cellValue = rowInfo.original[cellKey].value;
                } else if (rowInfo.original[cellKey].doc_count !== undefined) {
                    cellValue = rowInfo.original[cellKey].doc_count;
                } else {
                    cellValue = 0;
                }
            
            let totalValue = 0;
            if (totalRow && totalRow[cellKey]) {
                if (totalRow[cellKey].values && totalRow[cellKey].values['50.0'] !== undefined) {
                    totalValue = totalRow[cellKey].values['50.0'];
                } else if (totalRow[cellKey].value !== undefined) {
                    totalValue = totalRow[cellKey].value;
                } else if (totalRow[cellKey].doc_count !== undefined) {
                    totalValue = totalRow[cellKey].doc_count;
                }
            }

            let absTotal = Math.abs(totalValue);
            let over20per = totalValue + (absTotal * 0.2);
            let less20per = totalValue - (absTotal * 0.2);

            if (cellValue && cellValue !== totalValue
                && !isNaN(cellValue) && isFinite(cellValue)) {
                if (cellValue >= over20per) {
                    styleObj.background = "#d8eaff";
                    styleObj.color = "#4181f7";
                    styleObj.fontWeight = "bold";
                } 
                if (cellValue <= less20per) {
                    styleObj.background = "#ffd6db";
                    styleObj.color = "#f74159";
                    styleObj.fontWeight = "bold";
                }
            }
        }
        return styleObj;
    }

    getColumnsData() {
        let {
            display_col,
            display_col_list,
            view_level,
            summary_base,
            summary_group,
            display_tag,
            display_tag_list
        } = this.props.state;

        let first_head = this.props.langText.Body.Date;
        let first_head_width = this.props.boardWidth.medium;

        if (view_level === "CallAnalysisSummaryByOperator") {
            if (summary_group === 'group') {
                first_head = this.props.langText.Body.OperatorGroupName;
                first_head_width =this.props.boardWidth.xlarge;
            } else {
                first_head = this.props.langText.Body.OperatorName;
            }
        } else if (view_level === "CallAnalysisSummaryByExtensionNumber") {
            first_head = this.props.langText.Body.ExtensionNumber
            first_head_width = this.props.boardWidth.xlarge;
        }

        const displayDataList = [
            {
                Header: first_head,
                width: first_head_width,
                accessor: "key_as_string",
                filterable: false,
                fixed: "left",
                Cell: data => {
                    let display_data = "";
                    // 行の種別を判定: グループ行か/メンバー行か/通常行か
                    const rowOriginal = data && data.row && data.row._original ? data.row._original : {};
                    const isGroup = !!rowOriginal.is_group;
                    const groupKey = data.value;
                    const isCollapsed = !!(this.props.collapsedGroups && this.props.collapsedGroups[groupKey]);
                    switch (view_level) {
                        case "CallAnalysisSummaryByExtensionNumber":
                            if (data.value === "none") {
                                display_data = this.props.langText.Body.ExtensionNumberNotFound;
                            } else {
                                display_data = data.value;
                            }
                            break;
                        case "CallAnalysisSummaryByOperator":
                            if (isGroup) {
                                // グループ行: アイコン(▶/▼)で開閉トグル、太字表示
                                display_data = (
                                    <div style={{ fontWeight: 'bold', cursor: 'pointer', textAlign: 'left' }} onClick={() => this.toggleGroup(groupKey)}>
                                        <FontAwesomeIcon icon={isCollapsed ? faChevronRight : faChevronDown} style={{ marginRight: 6 }} />
                                        {data.value}
                                    </div>
                                );
                            } else {
                                if (data.value === "none") {
                                    display_data = this.props.langText.Body.OperatorNotFound;
                                } else {
                                    display_data = (
                                        <div>{data.value}</div>
                                    );
                                }
                            }
                            break;
                        case "CallAnalysisSummaryByDay":
                            display_data = moment(data.value).format("YYYY-MM-DD");
                            break;
                        case "CallAnalysisSummaryByWeek":
                            display_data = <div>
                                                <div>
                                                    {moment(data.value).format("YYYY-MM-DD")}
                                                </div>
                                                <div>
                                                    {"~" + moment(data.value).add(6, "days").format("YYYY-MM-DD")}
                                                </div>
                                            </div>
                            break;
                        case "CallAnalysisSummaryByMonth":
                            display_data = `${moment(data.value).format("YYYY-MM")}`;
                            break;
                        default:
                            break;
                    }
                    if (data.value === "average") {
                        display_data = this.props.langText.Body.AverageValue;
                    } else if (data.value === "median") {
                        display_data = this.props.langText.Body.MedianValue;
                    }

                    return display_data
                }
            },
            {
                Header: this.props.langText.Body.TotalCallCnt, //総発着信数
                width: this.props.boardWidth.medium,
                accessor: "total_call_count",
                getProps: (state, rowInfo, column) => {
                    return {
                        style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "total_call_count") : {}
                    };
                },
                filterable: false,
                fixed: "left",
                Cell: data => {
                    let display_data = "";
                    let countValue = 0;
                    if (data && data.value) {
                        if (data.value.values && data.value.values['50.0'] !== undefined) {
                            countValue = data.value.values['50.0'];
                        } else if (data.value.value !== undefined) {
                            countValue = data.value.value;
                        } else if (data.value.doc_count !== undefined) {
                            countValue = data.value.doc_count;
                        }
                    }
                    if (countValue) {
                        display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                    } else {
                        display_data = 0;
                    }
                    return display_data + ` ${this.props.langText.Body.TimeCount}`;
                }
            }
        ];

        if (summary_base === "default") {
            displayDataList.push(
                {
                    Header: this.props.langText.Body.TotalCallConnectCount, //接続数（接続率）
                    width: this.props.boardWidth.medium,
                    accessor: "total_connection_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "total_connection_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "total_connection_count"),
                    Cell: data => {
                        let display_data = "0";
                        let connection_rate = "0";
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        if (countValue) {
                            display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (data.row && data.row._original && data.row._original.total_call_count) {
                            let totalCallValue = 0;
                            if (data.row._original.total_call_count.values && data.row._original.total_call_count.values['50.0'] !== undefined) {
                                totalCallValue = data.row._original.total_call_count.values['50.0'];
                            } else if (data.row._original.total_call_count.value !== undefined) {
                                totalCallValue = data.row._original.total_call_count.value;
                            } else if (data.row._original.total_call_count.doc_count !== undefined) {
                                totalCallValue = data.row._original.total_call_count.doc_count;
                            }
                            if (totalCallValue && countValue) {
                                connection_rate = parseFloat((countValue / totalCallValue) * 100).toFixed(0).toLocaleString();
                            }
                        }
                        return display_data + ` ${this.props.langText.Body.TimeCount}` + 
                                " (" + connection_rate + this.props.langText.Body.Percent + ")";
                    }
                },
                // 通話時間帯（30秒以下、30秒～1分、1分～3分、3分～5分、5分以上）を接続数の直後に配置し、N回（%）で表示
                {
                    Header: this.props.langText.Body.CallTimeCount_0_30, //30秒以下
                    width: this.props.boardWidth.medium,
                    accessor: "billsec_le_30_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec_le_30_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec_le_30_count"),
                    Cell: data => {
                        let countDisplay = 0;
                        let percentDisplay = 0;
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        const totalConn = data && data.row && data.row._original 
                            && data.row._original.total_connection_count 
                            && data.row._original.total_connection_count.value 
                                ? data.row._original.total_connection_count.value : 0;
                        if (countValue) {
                            countDisplay = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (totalConn && totalConn > 0) {
                            percentDisplay = Math.round((countValue / totalConn) * 100).toLocaleString();
                        }
                        return `${countDisplay} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                    }
                },
                {
                    Header: this.props.langText.Body.CallTimeCount_30_60, //30秒～1分
                    width: this.props.boardWidth.medium,
                    accessor: "billsec_30_60_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec_30_60_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec_30_60_count"),
                    Cell: data => {
                        let countDisplay = 0;
                        let percentDisplay = 0;
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        const totalConn = data && data.row && data.row._original 
                            && data.row._original.total_connection_count 
                            && data.row._original.total_connection_count.value 
                                ? data.row._original.total_connection_count.value : 0;
                        if (countValue) {
                            countDisplay = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (totalConn && totalConn > 0) {
                            percentDisplay = Math.round((countValue / totalConn) * 100).toLocaleString();
                        }
                        return `${countDisplay} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                    }
                },
                {
                    Header: this.props.langText.Body.CallTimeCount_60_180, //1分～3分
                    width: this.props.boardWidth.medium,
                    accessor: "billsec_60_180_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec_60_180_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec_60_180_count"),
                    Cell: data => {
                        let countDisplay = 0;
                        let percentDisplay = 0;
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        const totalConn = data && data.row && data.row._original 
                            && data.row._original.total_connection_count 
                            && data.row._original.total_connection_count.value 
                                ? data.row._original.total_connection_count.value : 0;
                        if (countValue) {
                            countDisplay = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (totalConn && totalConn > 0) {
                            percentDisplay = Math.round((countValue / totalConn) * 100).toLocaleString();
                        }
                        return `${countDisplay} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                    }
                },
                {
                    Header: this.props.langText.Body.CallTimeCount_180_300, //3分～5分
                    width: this.props.boardWidth.medium,
                    accessor: "billsec_180_300_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec_180_300_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec_180_300_count"),
                    Cell: data => {
                        let countDisplay = 0;
                        let percentDisplay = 0;
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        const totalConn = data && data.row && data.row._original 
                            && data.row._original.total_connection_count 
                            && data.row._original.total_connection_count.value 
                                ? data.row._original.total_connection_count.value : 0;
                        if (countValue) {
                            countDisplay = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (totalConn && totalConn > 0) {
                            percentDisplay = Math.round((countValue / totalConn) * 100).toLocaleString();
                        }
                        return `${countDisplay} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                    }
                },
                {
                    Header: this.props.langText.Body.CallTimeCount_300_over, //5分以上
                    width: this.props.boardWidth.medium,
                    accessor: "billsec_ge_300_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec_ge_300_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec_ge_300_count"),
                    Cell: data => {
                        let countDisplay = 0;
                        let percentDisplay = 0;
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        const totalConn = data && data.row && data.row._original 
                            && data.row._original.total_connection_count 
                            && data.row._original.total_connection_count.value 
                                ? data.row._original.total_connection_count.value : 0;
                        if (countValue) {
                            countDisplay = parseFloat(countValue.toFixed(2)).toLocaleString();
                        }
                        if (totalConn && totalConn > 0) {
                            percentDisplay = Math.round((countValue / totalConn) * 100).toLocaleString();
                        }
                        return `${countDisplay} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                    }
                },
                {
                    Header: this.props.langText.Body.TotalCallTime, //総通話時間
                    width: this.props.boardWidth.medium,
                    accessor: "total_billsec",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "total_billsec") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "total_billsec"),
                    Cell: data => {
                        function addZero(num) {
                            return ((num < 10) ? '0' : '') + num
                        }
                        let display_data = "";
                        let timeValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                timeValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                timeValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                timeValue = data.value.doc_count;
                            }
                        }
                        if (timeValue) {
                            let time = Math.round(timeValue);
                            let hour = parseInt(time / 3600);
                            let min = parseInt((time % 3600) / 60);
                            let sec = parseInt(time % 60);
                            display_data = addZero(hour) + ":" + addZero(min) + ":" + addZero(sec);
                        } else {
                            display_data = "00:00:00";
                        }
                        return display_data;
                    }
                },
                {
                    Header: this.props.langText.Body.Score, //総合評価
                    width: this.props.boardWidth.medium,
                    accessor: "total_score",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "total_score") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "total_score"),
                    Cell: data => {
                        let display_data = "";
                        let scoreValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                scoreValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                scoreValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                scoreValue = data.value.doc_count;
                            }
                        }
                        if (scoreValue) {
                            display_data = parseInt(scoreValue).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        const scoreMaxUnit = `/${this.props.ct607Settings ? this.props.ct607Settings.score_max : 100}`;
                        return display_data + scoreMaxUnit;
                    }
                },
                {
                    Header: this.props.langText.Body.TalkingTime, //通話時間
                    width: this.props.boardWidth.medium,
                    accessor: "billsec",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "billsec") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "billsec"),
                    Cell: data => {
                        function addZero(num) {
                            return ((num < 10) ? '0' : '') + num
                        }
                        let display_data = "";
                        let timeValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                timeValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                timeValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                timeValue = data.value.doc_count;
                            }
                        }
                        if (timeValue) {
                            let time = Math.round(timeValue);
                            let hour = parseInt(time / 3600);
                            let min = parseInt((time % 3600) / 60);
                            let sec = parseInt(time % 60);
                            display_data = addZero(hour) + ":" + addZero(min) + ":" + addZero(sec);
                        } else {
                            display_data = "00:00:00";
                        }
                        return display_data;
                    }
                },
                {
                    Header: this.props.langText.Body.SilenceCount, //無音回数
                    width: this.props.boardWidth.medium,
                    accessor: "silence_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "silence_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "silence_count"),
                    Cell: data => {
                        let display_data = "";
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        if (countValue) {
                            display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + ` ${this.props.langText.Body.TimeCount}`;
                    }
                },
                {
                    Header: this.props.langText.Body.TalkRate, //OP会話比率
                    width: this.props.boardWidth.medium,
                    accessor: "talk_per",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "talk_per") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "talk_per"),
                    Cell: data => {
                        let display_data = "";
                        let perValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                perValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                perValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                perValue = data.value.doc_count;
                            }
                        }
                        if (perValue) {
                            display_data = parseFloat(perValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + " %";
                    }
                },
                {
                    Header: this.props.langText.Body.TalkConflictCount, //重なり回数
                    width: this.props.boardWidth.medium,
                    accessor: "talk_conflict_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "talk_conflict_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "talk_conflict_count"),
                    Cell: data => {
                        let display_data = "";
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        if (countValue) {
                            display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + ` ${this.props.langText.Body.TimeCount}`;
                    }
                },
                {
                    Header: this.props.langText.Body.TalkSpeed, //会話速度
                    width: this.props.boardWidth.medium,
                    accessor: "operator_talk_speed",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_talk_speed") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_talk_speed"),
                    Cell: data => {
                        let display_data = "";
                        let speedValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                speedValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                speedValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                speedValue = data.value.doc_count;
                            }
                        }
                        if (speedValue) {
                            display_data = parseFloat(speedValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + ` ${this.props.langText.Body.CharactersPerSecond}`
                    }
                },
                {
                    Header: this.props.langText.Body.TalkSpeedDifference, //会話速度差
                    width: this.props.boardWidth.medium,
                    accessor: "operator_talk_speed_diff",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_talk_speed_diff") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_talk_speed_diff"),
                    Cell: data => {
                        let display_data = "";
                        let diffValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                diffValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                diffValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                diffValue = data.value.doc_count;
                            }
                        }
                        if (diffValue && diffValue != "NaN" && isFinite(diffValue)) {
                            display_data = parseFloat(diffValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + " %";
                    }
                },
                {
                    Header: this.props.langText.Body.RallyingCount, //会話の往復回数
                    width: this.props.boardWidth.medium,
                    accessor: "rallying_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "rallying_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "rallying_count"),
                    Cell: data => {
                        let display_data = "";
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        if (countValue) {
                            display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + ` ${this.props.langText.Body.TimeCount}`;
                    }
                },
                {
                    Header: this.props.langText.Body.FillerCount, //フィラー回数（回/分）
                    width: this.props.boardWidth.medium,
                    accessor: "filler_count",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "filler_count") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "filler_count"),
                    Cell: data => {
                        let display_data = "";
                        let countValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                countValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                countValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                countValue = data.value.doc_count;
                            }
                        }
                        if (countValue || countValue === 0) {
                            display_data = parseFloat(countValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return `${display_data} ${this.props.langText.Body.CountPerMinute}`;
                    }
                },
                {
                    Header: this.props.langText.Body.Frequency, //基本周波数
                    width: this.props.boardWidth.medium,
                    accessor: "operator_frequency_average",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_frequency_average") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_frequency_average"),
                    Cell: data => {
                        let display_data = "";
                        let freqValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                freqValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                freqValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                freqValue = data.value.doc_count;
                            }
                        }
                        if (freqValue) {
                            display_data = parseFloat(freqValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + " Hz";
                    }
                },
                {
                    Header: this.props.langText.Body.FrequencyDifference, //基本周波数の差
                    width: this.props.boardWidth.medium,
                    accessor: "operator_frequency_average_diff",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_frequency_average_diff") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_frequency_average_diff"),
                    Cell: data => {
                        let display_data = "";
                        let diffValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                diffValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                diffValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                diffValue = data.value.doc_count;
                            }
                        }
                        if (diffValue) {
                            display_data = parseFloat(diffValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + " %";
                    }
                },
                {
                    Header: this.props.langText.Body.Accent, //音声のメリハリ
                    width: this.props.boardWidth.medium,
                    accessor: "operator_accent",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_accent") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_accent"),
                    Cell: data => {
                        let display_data = "";
                        let accentValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                accentValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                accentValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                accentValue = data.value.doc_count;
                            }
                        }
                        if (accentValue) {
                            display_data = parseFloat(accentValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data;
                    }
                },
                {
                    Header: this.props.langText.Body.AccentDifference, //音声のメリハリの差
                    width: this.props.boardWidth.medium,
                    accessor: "operator_accent_diff",
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, "operator_accent_diff") : {}
                        };
                    },
                    filterable: false,
                    show: display_col_list.length === display_col.length || display_col.some(row => row.value === "operator_accent_diff"),
                    Cell: data => {
                        let display_data = "";
                        let diffValue = 0;
                        if (data && data.value) {
                            if (data.value.values && data.value.values['50.0'] !== undefined) {
                                diffValue = data.value.values['50.0'];
                            } else if (data.value.value !== undefined) {
                                diffValue = data.value.value;
                            } else if (data.value.doc_count !== undefined) {
                                diffValue = data.value.doc_count;
                            }
                        }
                        if (diffValue) {
                            display_data = parseFloat(diffValue.toFixed(2)).toLocaleString();
                        } else {
                            display_data = 0;
                        }
                        return display_data + " %";
                    }
                }
            );
        } else {
            display_tag_list.forEach(row => {
                displayDataList.push(
                    {
                        Header: row.label, 
                        width: this.props.boardWidth.medium,
                        accessor: `tag_per_${row.value}`,
                        getProps: (state, rowInfo, column) => {
                            return {
                                style: this.state.data.length > 0 ? this.getCellStyle(rowInfo, `tag_per_${row.value}`) : {}
                            };
                        },
                        filterable: false,
                        show: display_tag_list.length === display_tag.length || display_tag.some(item => item.value === row.value),
                        Cell: data => {
                            let display_data = "";
                            let tagValue = 0;
                            if (data && data.value) {
                                if (data.value.values && data.value.values['50.0'] !== undefined) {
                                    tagValue = data.value.values['50.0'];
                                } else if (data.value.value !== undefined) {
                                    tagValue = data.value.value;
                                } else if (data.value.doc_count !== undefined) {
                                    tagValue = data.value.doc_count;
                                }
                            }
                            if (tagValue) {
                                display_data = parseFloat(tagValue.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }

                            return display_data + " %";
                        }
                    }
                )
            });
        }

        return displayDataList;
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col xs={12} md={12}>
                        <ColumnFixTable
                            talbeRef={this.table}
                            style={{ height: this.props.tableHeight }}
                            manual="manual"
                            columns={this.state.columns}
                            data={this.buildDisplayData()}
                            pages={this.state.pages}
                            defaultSorted={[this.props.state.sorted]}
                            onSortedChange={(newSorted) => {
                                let sorted = newSorted.length > 0 ? newSorted[0] : {};
                                if (sorted) {
                                    this.props.propSetState({sorted});
                                    this.props.onSummary(sorted);
                                }
                            }}
                            filtered={this.state.filtered}
                            previousText={this.props.langText.Table.PreviousText}
                            nextText={this.props.langText.Table.NextText}
                            noDataText={this.props.langText.Table.NoDataText}
                            rowsText={this.props.langText.Table.RowsText}
                            showPaginationBottom={false}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}
